var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body"},[_c('StoreLogTable',{attrs:{"query-type":"seller","hide-columns":['boxReceiptCode','transferCount','totalReceiveCount','receiverName'],"hide-buttons":['receive','price','back'],"hide-query":['orderCode','boxReceiptCode']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }